import styled from "@emotion/styled";
import { IntercomLogo } from "components/Icons";
import { Socials } from "./Socials";
import { Spacer } from "components/general/Spacer/Spacer";
import { useIsDesktop } from "hooks/useDeviceType";
import { getNavbarButtonOptions } from "../NavbarV2Desktop";

export const SideNavSocials = () => {
  const isDesktop = useIsDesktop();
  return (
    <Container>
      <Socials />
      {!isDesktop && (
        <>
          <Spacer height="16px" />
          <IntercomLogo className="open-intercom-gtm" />
        </>
      )}
    </Container>
  );
};

// Sub-components

const Container = styled.div`
  grid-area: 1 / ${props => getNavbarButtonOptions(props.theme).length + 1} / 2 /
    ${props => getNavbarButtonOptions(props.theme).length + 2};
`;
